<template>
    <div>
        <div class="row">
            <div class="col col-12">
                <az-input
                    label="Nome da Clínica"
                    required
                    :validate="validate"
                    v-model="dados.st_nome_fantasia" />
            </div>
        </div>

        <div class="row">
            <div class="col col-12">
                <az-input
                    label="Nome da Clínica"
                    required
                    :validate="validate"
                    v-model="dados.st_nome_fantasia" />
            </div>
        </div>
    </div>
</template>

<script>
import AzInput from '../shared/forms/AzInput.vue';

export default {
    data() { 
        return { 
            dados: {},
            validate: false, 
        };
    },

    components: { 
        AzInput,
    }
}
</script>